"use client";

import { motion } from "framer-motion";
import Image from "next/image";
import TextReveal from "./textReveal";

interface ScrollSectionProps {
  direction?: "left" | "right";
  imageSrc?: string;
  alt: string;
  text: string;
  title?: string;
  tagline: string;
}

const ScrollSection: React.FC<ScrollSectionProps> = ({
  direction = "left",
  imageSrc,
  alt,
  text,
  title,
  tagline,
}) => {
  const isReverse = direction === "right";

  return (
    <section className="relative bg-white text-gray-900 overflow-hidden py-8 px-3 md:px-16">
        <Image
        src="/background-image1.png"
        alt="Background"
        fill
        quality={100}
        className="object-cover z-0"
        priority
      /> 
      {/* Content Grid */}
      <div
        className={`mx-auto flex flex-col lg:flex-row justify-center max-w-screen-lg gap-4 md:gap-12 items-center ${
          isReverse ? "lg:flex-row-reverse" : ""
        }`}
      >
        {/* Visual */}
        {imageSrc && <motion.div
          initial={{ opacity: 0, x: isReverse ? 50 : -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="relative w-full h-ful "
        >
          <Image
            src={imageSrc}
            alt={alt}
            width={500}
            height={500}
            className="hover:opacity-100 transition duration-500 rounded-md h-full w-auto object-cover"
          />
        </motion.div>}

        {/* Text Content */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.9 }}
          className="backdrop-blur-md border border-purple-400/50 rounded-xl shadow-xl p-4 md:p-10 text-center"
        >
          {title && (
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-3xl md:text-4xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-white to-purple-600 mb-4"
            >
              {title}
            </motion.h2>
          )}

          <p className="text-sm uppercase text-purple-300 mb-6 tracking-wider font-medium">
            {tagline}
          </p>

          <TextReveal
            splitBy="word"
            className="text-base md:text-lg font-light text-white text-justify leading-relaxed"
            text={text}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default ScrollSection;
